(function() {
    'use strict';

    angular
        .module('TR')
        .controller('HotelSearch', HotelSearch);

    function HotelSearch(pagingService,
        urlUtils,
        pageStrand,
        preferences,
        arrayUtil,
        windowUtil,
        $q,
        $scope,
        $location,
        $window,
        $interval,
        $filter,
        flightSearch,
        hotelSearch,
        $routeParams,
        hotelService,
        basketService,
        cookieService,
        basketStore,
        searchUnitService,
        occupancyService,
        broker,
        tripService,
        resourceService,
        loggingService,
        reviewService,
        imageService,
        infoPopupService,
        locationService,
        hotelsFilter,
        analytics,
        currentDestination,
        getPropertyTypeFromResKey,
        $rootScope,
        $route,
        fidParser,
        abTest,
        destinationService,
        urlStoreService,
        holidayStartDateGuardService,
        $locale) {
        const EnableForceLoading = TRPCONFIG.Domain.EnableHolidaySearchForceLoading;
        if (EnableForceLoading) {
            _block();
        }
        const cm = this;
        let selectedHotel;
        const timerKey = 'modifying hotel list criteria';
        const boards = [
            'MIXEDROOM',
            'ROOMONLY',
            'BEDANDBREAKFAST',
            'HALFBOARD',
            'FULLBOARD',
            'ALLINCLUSIVE',
            'SELFCATERING'
        ];
        const { tripId } = $routeParams;

        cm.starName = starName;
        cm.addingFlight = basketStore.addingFlight();
        cm.applyFilters = applyFilters;
        cm.applySort = applySort;
        cm.boardTypePriceText = TRPCONFIG.Domain.BoardTypePriceText;
        cm.lockMultiDestUI = false;
        cm.hotelsFilterOrderABTest = TRPCONFIG.Domain.HotelsFilterOrderABTest;
        cm.maxPassengers = TRPCONFIG.Domain.MaxPassengers;
        TRPCONFIG.Domain.FlightMiles = [];
        cm.priceMode = 1;

        cm.fid = fidParser.parse();
        cm.filterTab = filterTab;
        cm.setTab = setTab;
        cm.listTab = listTab;
        cm.infoTab = infoTab;
        cm.page = page;
        cm.priceModeTrace = null;
        cm.removeArrayFilter = removeArrayFilter;
        cm.removeFilter = removeFilter;
        cm.req = hotelSearch.getAvailabilityRequest();
        cm.requestedHotelNotAvailable = requestedHotelNotAvailable;
        cm.resetFilters = resetFilters;
        cm.setFilterHolidayPriceRange = setFilterHolidayPriceRange;
        cm.resetRangeFilter = resetRangeFilter;
        cm.resetArrayFilter = resetArrayFilter;
        cm.resetBitFilter = resetBitFilter;
        cm.showSpinner = showSpinner;
        cm.sortCriteria = hotelSearch.getSortCriteria();
        cm.sortTab = sortTab;
        cm.startAgain = startAgain;
        cm.tab = 'list';
        cm.seo = false;
        cm.pollingInterval = null;
        cm.tabClass = tabClass;
        cm.isHotelFilterVisible = TRPCONFIG.Domain.SeasonalDeals && TRPCONFIG.Domain.SeasonalDeals.isHotelFilterVisible;
        cm.enableBoardTypeFilter = tripId != null;
        cm.isHoliday = $route.current && $route.current.area === 'holidays';
        tripService.usePackageRates().then(packagePrice => cm.packagePrice = packagePrice);
        cm.showStrikethroughPrice = TRPCONFIG.Domain.EnableStrikethroughPrices;
        cm.isBrandedFareUpdated = TRPCONFIG.Domain.IsBrandedFareUpdated;

        // Desktop
        cm.showMap = false;
        cm.toggleMap = toggleMap;
        cm.popupMap = popupMap;
        cm.showPopupMap = false;
        cm.showReviews = showReviews;
        cm.reviewsShowing = false;

        cm.openSlideFilter = openSlideFilter;
        cm.showSlideFilter = false;
        cm.showSelectedHotelV2 = TRPCONFIG.Domain.ShowSelectedHotelV2;
        cm.enableLabelOfRecentlyViewedHotel = (cm.showSelectedHotelV2 || basketService.isFlightPreselected()) && sessionStorage.getItem('preselectedHotelData') !== null
            ? false
            : TRPCONFIG.Domain.EnableLabelOfRecentlyViewedHotel;

        // for lightbox gallery
        cm.openImageGallery = openImageGallery;
        cm.hotelImages = null;
        cm.showHotelImages = false;
        cm.hotelImageIndex = 0;

        cm.showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
        cm.toggleSearchUnit = toggleSearchUnit;
        cm.HFJShowSearch = false;
        cm.toggleHFJShowSearch = toggleHFJShowSearch;
        cm.setPriceDigits = setPriceDigits;
        cm.showInvalidHolidayStartDateModal = false;
        cm.closeInvalidHolidayStartDateModal = closeInvalidHolidayStartDateModal;

        cm.updating = false;
        cm.showAllDestinations = false;
        cm.toggleDestinations = toggleDestinations;
        cm.showBreadcrumb = false;
        cm.destinationThumb = destinationThumb;
        cm.budgetRadioBtnEnabled = TRPCONFIG.Domain.BudgetRadioBtnInsteadSliderRange;
        // DesktopEnd

        cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        cm.isSeasonalDeals = isSeasonalDeals;
        cm.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
        cm.hotelsChunkNumber = 1;
        cm.isPagingDisabled = false;
        cm.isHotelFirstJourney = false;
        cm.selectedEstabId = $location.search().selectedEstabId ? parseInt($location.search().selectedEstabId) : undefined;

        cm.promoColour = 'none';
        cm.facilitiesIcons = {
            AC: 'air_conditioning.svg',
            BA: 'bar.svg',
            BC: 'do_not_show',
            CC: 'kids_club.svg',
            DF: 'accessibility.svg',
            GF: 'golf.svg',
            GM: 'gym.svg',
            HA: 'no_icon',
            HB: 'close_to_beach.svg',
            HC: 'couples.svg',
            HF: 'family.svg',
            HK: 'no_icon',
            HN: 'no_icon',
            HQ: 'boutique_label.svg',
            HS: 'no_icon',
            HT: 'no_icon',
            HU: 'no_icon',
            HV: 'no_icon',
            IN: 'wifi.svg',
            PA: 'no_icon',
            PK: 'parking.svg',
            RS: 'restaurant.svg',
            SP: 'spa.svg',
            SW: 'pool.svg',
            TV: 'do_not_show',
            WN: 'no_icon',
            WP: 'no_icon'
        };

        $scope.$watchGroup(
            ['cm.nonInfants', 'cm.numNights', 'cm.priceMode', 'cm.isLanding', 'cm.currency'],
            function(args) {
                if (_(args).some(x => x == null)) {
                    return;
                }

                if (TRPCONFIG.Domain.PriceBucketFilterEnabled || cm.budgetRadioBtnEnabled) {
                    cm.holidayPriceRangeBuckets = [];
                    let priceBuckets = [];
                    if (cm.isHoliday && cm.agg.HolidayPriceRange) {
                        if (cm.packagePrice) {
                            priceBuckets = TRPCONFIG.Domain.PackagePriceBuckets;
                        } else {
                            priceBuckets = TRPCONFIG.Domain.HolidayPriceBuckets;
                        }
                        cm.holidayPriceRangeBuckets = [{ value: cm.agg.HolidayPriceRange.Max, label: resourceService.get('RADIOPRICEFILTERNOMAXLABEL') }];
                    } else {
                        priceBuckets = TRPCONFIG.Domain.HotelPriceBuckets;
                        cm.holidayPriceRangeBuckets = [{ value: cm.agg.PriceRange.Max, label: resourceService.get('RADIOPRICEFILTERNOMAXLABEL') }];
                    }
                    _.forEach(priceBuckets, value => {
                        let bucket = { value, label: '' };
                        bucket.value *= cm.nonInfants;
                        bucket.label = String.format(resourceService.get('RADIOPRICEFILTERUPTO'),
                            $filter('roundedCurrency')(bucket.value, cm.currency));
                        if (cm.priceMode === 0) {
                            bucket.label = String.format(resourceService.get('RADIOPRICEFILTERUPTO'),
                                $filter('roundedCurrency')(bucket.value / cm.nonInfants, cm.currency));
                        }
                        cm.holidayPriceRangeBuckets.push(bucket);
                    });

                    if (cm.budgetRadioBtnEnabled) {
                        let noMaxBucket = cm.holidayPriceRangeBuckets.shift();
                        cm.holidayPriceRangeBuckets.push(noMaxBucket);

                    }
                }

                cm.priceRangeConfig = abTest.progressiveHotelSearchEnabled() ? {
                    Min: 0,
                    Max: cm.nonInfants * cm.numNights * TRPCONFIG.Domain.PriceRangeConfigPricePerRoomPerPerson,
                    Plus: '+',
                    edgesBecomeNull: {
                        Min: true,
                        Max: true,
                    },
                } : {
                    Min: cm.agg.PriceRange.Min,
                    Max: cm.agg.PriceRange.Max,
                };

                _(['Min', 'Max']).forEach(key => {
                    cm.priceRangeConfig[`${key}Formatted`] = cm.formatPriceByPriceMode(cm.priceRangeConfig[`${key}`]);
                });
            });

        cm.showFreeCancellationMessage = function(hotel) {
            if (hotel && hotel.RequestedRooms && hotel.RequestedRooms.length && hotel.RequestedRooms[0].BoardTypeMinPrices.length
                && hotel.RequestedRooms[0].BoardTypeMinPrices[0].NonRefundable) {
                    return hotel.RequestedRooms[0].BoardTypeMinPrices[0].NonRefundable;
            }
        };

        cm.getIsMandatory = function(h) {
            return hotelSearch.getMaldivesIsMandatory(h);
        };

        cm.hasStoreSelectedFlight = function() {
            return sessionStorage.getItem('storeSelectedFlight');
        };

        cm.ratingRangeConfig = {
            Min: 0,
            Max: 10,
            edgesBecomeNull: {
                Min: abTest.progressiveHotelSearchEnabled(),
            },
        };

        cm.formatPriceByPriceMode = price => {
            if (price == null) {
                return null;
            }
            if (cm.priceMode !== 1 && !cm.isLanding) {
                price /= cm.nonInfants;
            }
            return $filter('roundedCurrency')(price, cm.currency);
        };

        cm.openDatePicker = function() {
            if (TRPCONFIG.Domain.ShowDatepickerTimeout !== 0) {
                setTimeout(() => {
                    let datepicker = $('.icon-calendar');
                    if (datepicker && datepicker[0] && datepicker['0'].nextElementSibling) {
                        datepicker['0'].nextElementSibling.click();
                    }
                }, TRPCONFIG.Domain.ShowDatepickerTimeout);
            }
        };
        cm.displayFlightMiles = function() {
            try {
                let flight = sessionStorage.getItem('SkywardsMilesFlights');
                flight = JSON.parse(flight);
                let miles;
                miles = flight;
                return miles;
            } catch (error) {}
        };
        scrollTo(0, 0);
        _block();

        broker.subscribe('HotelCtrl', 'seoContentLoaded', function() {
            cm.seo = true;
        });

        broker.subscribe('HotelCtrl', 'priceModeChanged', function(ev) {
            console.log('subscribe');
            $location.search('priceMode', ev.data).replace();
            cm.priceMode = ev.data;
            cm.resetRangeFilter('HolidayPriceRange', ['Min', 'Max']);
            setFilterHolidayPriceRange();
        });

        broker.subscribe('HotelCtrl', 'searchCriteriaModified', function() {
            cm.updating = true;
            setFilterHolidayPriceRange();
            analytics.startTimer(timerKey);
            cm.hotelsChunkNumber = 1;
        });

        function _subscribeToModifications() {
            broker.subscribe('HotelCtrl', 'hotelResultsModified', function(ev) {
                _modifyResults(ev.data);
            });
        }
        function getDepartureCode(legs) {
            for (let i = 0; i < legs.length; i++) {
                if (legs[i].LegType === 'outbound') {
                    return legs[i].DepartureAirport.Code;
                }
            }
        }

        function getDestinationCode(legs) {
            for (let i = 0; i < legs.length; i++) {
                if (legs[i].LegType === 'outbound') {
                    return legs[i].ArrivalAirport.Code;
                }
            }
        }
        function getFareBrandTitle(supplierfareclass) {
            switch (supplierfareclass) {
                case 'F':
                    return 'First Flex Plus';
                case 'A':
                    return 'First Flex';
                case 'Z':
                    return 'First Others';
                case 'J':
                    return 'Business Flex Plus';
                case 'C':
                    return 'Business Flex Plus';
                case 'I':
                    return 'Business Flex';
                case 'O':
                    return 'Business Saver';
                case 'H':
                    return 'Business Special';
                case 'D':
                    return 'Business Others';
                case 'P':
                    return 'Business Others';
                case 'W':
                    return 'Premium Economy Flex Plus';
                case 'E':
                    return 'Premium Economy Flex Plus';
                case 'N':
                    return 'Premium Economy Others';
                case 'Y':
                    return 'Economy Flex Plus';
                case 'R':
                    return 'Economy Flex Plus';
                case 'M':
                    return 'Economy Flex';
                case 'B':
                    return 'Economy Flex';
                case 'U':
                    return 'Economy Flex';
                case 'K':
                    return 'Economy Flex';
                case 'Q':
                    return 'Economy Saver';
                case 'L':
                    return 'Economy Saver';
                case 'T':
                    return 'Economy Saver';
                case 'X':
                    return 'Economy Special';
                case 'V':
                    return 'Economy Saver';
                case 'G':
                    return 'Economy Others';
                case 'S':
                    return 'Economy Others';
                default:
                    return '';
            }
        }

        async function getFlightMilesEachPassenger() {
            let defaultFlight = JSON.parse(sessionStorage.getItem('DefaultFlight'));
            let storeSelectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight')) ?
            JSON.parse(sessionStorage.getItem('storeSelectedFlight')) : defaultFlight ?
            defaultFlight.Details.Itinerary : null;

            if (storeSelectedFlight) {
                let legs = storeSelectedFlight.Legs;
                let flight = storeSelectedFlight;
                let origin = getDepartureCode(legs);
                let destination = getDestinationCode(legs);
                let spplierClassFirstLeg = flight.Legs[0].Segments[0].SupplierFareClass;
                let spplierClassSecondLeg = flight.Legs[1].Segments[0].SupplierFareClass;
                let getBrandTitleFirstLeg = getFareBrandTitle(spplierClassFirstLeg);
                let getBrandTitleSecondLeg = getFareBrandTitle(spplierClassSecondLeg);
                let skywardFlightMile;

                if (getBrandTitleFirstLeg !== '' && getBrandTitleSecondLeg !== '') {
                    let journeyType;
                    if (getBrandTitleFirstLeg === getBrandTitleSecondLeg) {
                        journeyType = 'RT';
                        let cabinTypeFirstLeg = flight.Legs[0].CabinType;
                        cabinTypeFirstLeg = languageCheck(cabinTypeFirstLeg);

                        let updatedFirstLegArr = getCabin(getBrandTitleFirstLeg, cabinTypeFirstLeg);
                        let fareBrandResult = updatedFirstLegArr.join('');
                        let cabinCode = getCabinCode(cabinTypeFirstLeg);

                        let skywardFlightMile = await getFlightMiles(origin, destination, cabinCode, journeyType, fareBrandResult);
                        sessionStorage.setItem('SkywardsMilesFlights', await skywardFlightMile);
                    } else {
                        journeyType = 'OW';
                        let cabinTypeFirstLeg = flight.Legs[0].CabinType;
                        let cabinTypeSecondLeg = flight.Legs[1].CabinType;
                        let fareBrandFirstLeg = getBrandTitleFirstLeg;
                        let fareBrandSecondLeg = getBrandTitleSecondLeg;

                        cabinTypeFirstLeg = languageCheck(cabinTypeFirstLeg);
                        cabinTypeSecondLeg = languageCheck(cabinTypeSecondLeg);

                        let updatedFirstLegArr = getCabin(fareBrandFirstLeg, cabinTypeFirstLeg);
                        let updatedSecondLegArr = getCabin(fareBrandSecondLeg, cabinTypeSecondLeg);

                        let fareBrandFirstLegResult = updatedFirstLegArr.join('');
                        let fareBrandSecondLegResult = updatedSecondLegArr.join('');

                        let cabinCodefirstLeg = getCabinCode(cabinTypeFirstLeg);
                        let cabinCodeSecondLeg = getCabinCode(cabinTypeSecondLeg);

                        let skywardFlightMileForFirstLeg = await getFlightMiles(origin, destination, cabinCodefirstLeg, journeyType, fareBrandFirstLegResult);

                        let skywardFlightMileForSecondLeg = await getFlightMiles(origin, destination, cabinCodeSecondLeg, journeyType, fareBrandSecondLegResult);

                        skywardFlightMile = await parseInt(skywardFlightMileForFirstLeg) + parseInt(skywardFlightMileForSecondLeg);
                        sessionStorage.setItem('SkywardsMilesFlights', await skywardFlightMile);
                    }
                }
            }

        }

        function languageCheck(cabinType) {
            switch (cabinType) {
                case 'Economy':
                case 'Økonomi klasse':
                case 'Economy Class':
                case 'Ekonomiklass':
                case 'الدرجة السياحية':
                case 'Clase Turista':
                    return 'Economy';
                case 'Premium Economy':
                case 'Premium ekonomiklass':
                case 'الدرجة الاقتصادية المميزة':
                case 'Clase Turista Premium':
                    return 'Premium Economy';
                case 'Business':
                case 'Business Class':
                case 'درجة رجال الأعمال':
                case 'Clase Business':
                    return 'Business';
                case 'First':
                case 'Erste Klasse':
                case 'Första klass':
                case 'الدرجة الأولى':
                case 'Primera clase':
                    return 'First';
                default:
                    return '';
            }
        }

        function getCabin(fareBrandLeg, cabinLeg) {
            let legArr = fareBrandLeg.split(' ');
            let updatedLegArr = [];
            legArr.forEach((cabin, i) => {
                if (cabin !== cabinLeg) {
                    if (i === 1) {
                        cabin = cabin.toLowerCase();
                    }
                    updatedLegArr.push(cabin);
                }
            });

            return updatedLegArr;
        }

        function getCabinCode(cabinType) {
            switch (cabinType) {
                case 'Economy':
                    return 'Y';
                case 'Premium Economy':
                    return 'W';
                case 'Business':
                    return 'J';
                case 'First':
                    return 'F';
                default:
                    return '';
            }
        }

        function getFlightMiles(origin, destination, cabinCodeLeg, journeyType, fareBrandLegResult) {
            return hotelSearch.getFlightMiles(origin, destination, cabinCodeLeg, journeyType)
                .then(result => {
                    if (result && result.getMilesFromCouchbase &&
                        result.getMilesFromCouchbase.miles &&
                        result.getMilesFromCouchbase.miles.earn &&
                        result.getMilesFromCouchbase.miles.earn.skywards[fareBrandLegResult]) {
                        return result.getMilesFromCouchbase.miles.earn.skywards[fareBrandLegResult].skywardsMiles;
                    }
                });
        }

        function _flightCosts(basketId) {
            return function() {
                basketStore.flightCost(basketId).then(function(c) {
                    cm.totalFlightCost = c;
                    cm.addingFlight = false;
                });
            };
        }

        function buildPagePaths(children) {
            return destinationService.sortByTitle(children).map(function(child) {
                child.PagePath = urlUtils.appendExistingQueryString(urlUtils.stripLeadingSlash(child.PagePath));
                return child;
            });
        }

        function toggleDestinations(e) {
            e.preventDefault();
            e.stopPropagation();
            if (!cm.showAllDestinations) {
                destinationService.getAllChildren(cm.destination).then(children => cm.all = buildPagePaths(children));
                cm.showAllDestinations = !cm.showAllDestinations;
            }
        }

        function destinationThumb(dest) {
            return destinationService.destinationThumb(dest);
        }

        if (tripId == null) {
            cm.destination = searchUnitService.getDestination();
            currentDestination.getCurrentDestination()
                .then(dest => {
                    let CountryOwnId = dest.CountryOwnId || null;

                    if (CountryOwnId != null) {
                        let isPagingMode = hotelService.getPaginationMode(CountryOwnId);

                        hotelSearch.clearSearchResults(false, isPagingMode);
                        if (isPagingMode) {
                            cm.req.Paging.Size = 12;
                            cm.isPagingDisabled = true;
                        }
                    } else {
                        hotelSearch.clearSearchResults();
                    }
                });

            hotelSearch.updateFilterFromFid()
                .then(() => hotelSearch.getSearchResults(null, true))
                .then(_setResults)
                .then(_subscribeToModifications)
                .then(_bindFilterData);

            cm.getHotelUrl = function getHotelUrl(hotel) {
                return urlUtils.stripLeadingSlash(pageStrand.adjustUrl(hotel.Url, cm.destination.PageStrand));
            };
            cm.selectHotel = function selectHotel(hotel, ev) {
                ev.preventDefault();

                const url = urlUtils.stripLeadingSlash(
                    pageStrand.adjustUrl(urlUtils.appendExistingQueryString(hotel.Url), cm.destination.PageStrand)
                );
                trackHotelClick(hotel, undefined);

                if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                    windowUtil.open(url);
                } else {
                    selectedHotel = hotel;
                    $location.url(url);
                }
                ev.stopPropagation();
            };

            cm.showSearchUnit = true;
            cm.showBreadcrumb = true;
        } else {
            //nothing can happen unless we can decipher the tripId

            hotelSearch.clearSearchResults();
            basketService.changeToHolidayTripType(tripId)
                .then(() => tripService.getTrip(tripId))
                .then(trip => {
                    const { BasketId, TripType, FlexibleTripType } = trip;
                    cm.showBreadcrumb = true;
                    cm.isFlexibleTripType = FlexibleTripType;
                    cm.hotelAvailabilitySearchId = _.get(trip, 'HotelsRequest.AvailabilitySearchId');
                    cm.roomsQuantity = trip.HotelsRequest && trip.HotelsRequest.Rooms ? trip.HotelsRequest.Rooms.length : 0;

                    cm.isMultiDestHoliday = TripType === tripService.tripTypes.MultiDestHoliday;
                    if (cm.isMultiDestHoliday) {
                        cm.requestedHotelNotAvailable = () => false;
                        cm.showBreadcrumb = false;
                        cm.showSearchUnit = true;
                    }

                    cm.isHotelFirstJourney = basketService.isFlightPreselected();

                    function getHotelUrl(hotel, pd) {
                        let url = basketService.getHotelUrl({
                            tripId: $routeParams.tripId,
                            hotel,
                            TripType
                        });
                        // append 'page section' parameter
                        if (pd) {
                            url += url.indexOf('?') === -1 ? '?'
                                : !url.endsWith('?') ? '&'
                                    : '';
                            url += `pd=${pd}`;
                        }
                        return url;
                    }

                    function saveHotelTracking(hotel) {
                        let hotelTracking = {
                            Revenue: hotel && hotel.MinCost ? hotel.MinCost : 0,
                            StartDate: trip.HotelsRequest.CheckInDate,
                            EndDate: trip.HotelsRequest.CheckOutDate,
                            HotelTitle: hotel && hotel.Title ? hotel.Title : null,
                            TotalPax: _(trip.HotelsRequest.Rooms)
                                .map(r => r.Adults + r.ChildAges.length)
                                .reduce((memo, num) => memo + num, 0)
                        };
                        console.log('saveHotelTracking', hotelTracking);
                        localStorage.setItem('gaHotelTracking', JSON.stringify(hotelTracking));
                    }

                    function triggerHotelSearchTracking() {
                        localStorage.setItem('gaHotelSearch', JSON.stringify({ category: 'searches', action: 'hotelPage' }));
                    }

                    document.addEventListener('contextmenu', function(e) {
                        let el = e.target.parentElement;
                        let hotel = JSON.parse(el.getAttribute('data-hotel'));
                        saveHotelTracking(hotel);
                        triggerHotelSearchTracking();
                    });

                    function getSelectedHolidayStartDate(hotel) {
                        return _.get(cm.flight, 'Details.Itinerary.Legs[0].Segments[0].DepartureDate')
                            || _.get(hotel, 'LinkedFlightDetails.OutboundLeg.Segments[0].DepartureDate')
                            || null;
                    }

                    function canUseSelectedHolidayStartDate(hotel) {
                        return holidayStartDateGuardService.canUseHolidayStartDate(getSelectedHolidayStartDate(hotel));
                    }

                    function openInvalidHolidayStartDateModal(ev) {
                        if (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }

                        cm.showInvalidHolidayStartDateModal = true;
                    }

                    function selectHotel(hotel, ev, area) {

                        if (!canUseSelectedHolidayStartDate(hotel)) {
                            openInvalidHolidayStartDateModal(ev);
                            return;
                        }

                        let newTab = false;
                        if (ev.type === 'click' && (ev.ctrlKey || ev.metaKey)) {
                            newTab = true;
                        } else if (ev.type === 'contextmenu') {
                            newTab = true;
                        }

                        if (cm.lockMultiDestUI) {
                            ev.preventDefault();
                            return;
                        }
                        try {
                            analytics.track('Event', 'SelectHotel', {
                                Revenue: hotel.MinCost,
                                StartDate: trip.HotelsRequest.CheckInDate,
                                EndDate: trip.HotelsRequest.CheckOutDate,
                                HotelTitle: hotel.Title,
                                TotalPax: _(trip.HotelsRequest.Rooms)
                                    .map(r => r.Adults + r.ChildAges.length)
                                    .reduce((memo, num) => memo + num, 0)
                            });
                        } catch (err) { }

                        //**Issue fix - In deep link journey flow is missing to call adjusthoteldate function. hence we
                        // are calling that function here with the help of  broker.publish('searchDatesAdjusted.....)  */
                        if (sessionStorage.getItem('PreselectFlight') === null || sessionStorage.getItem('PreselectFlight') === undefined) {
                            try {
                                sessionStorage.setItem('IsDeepLinkURL', true);
                                const newHotelsRequestDates = {};
                                newHotelsRequestDates.CheckInDate = trip.HotelsRequest.CheckInDate;
                                newHotelsRequestDates.CheckOutDate = trip.HotelsRequest.CheckOutDate;
                                broker.publish('searchDatesAdjusted', { tripId, dates: newHotelsRequestDates });
                            } catch (err) { }
                        }

                        ev.preventDefault();
                        if (!TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                            selectedHotel = hotel;
                        }
                        if (cm.isMultiDestHoliday) {
                            if (EnableForceLoading) {
                                _block();
                            }
                            selectedHotel = hotel;
                            cm.lockMultiDestUI = true;
                            hotelSearch.getTripForSelectedMultiDestHoliday(tripId, hotel)
                                .then(newTripId => {
                                    return hotelSearch.getFlightDetailsForSelectedMultiDestHoliday(newTripId, hotel)
                                        .then(flight => flightSearch.setBags(trip, flight).then(() => flight))
                                        .then(flight => basketService.selectFlight(flight, newTripId, {
                                            bags: flight.bags,
                                            maxbags: occupancyService.getNumberOfNonInfantPassengers() || 1
                                        }))
                                        // Can't launch new window because browsers block the popup due to async
                                        .then(() => {
                                            return basketService.selectHotel(newTripId, hotel, BasketId, area, true);
                                        });
                                });
                        } else {
                            basketService.selectHotel($routeParams.tripId, hotel, BasketId, area, false, newTab);
                        }

                        trackHotelClick(hotel, trip);
                        ev.stopPropagation();
                    }

                    function _postProcessResults(results) {
                        if (EnableForceLoading) {
                            _block();
                        }
                        _setResults(results)
                            .then(_subscribeToModifications)
                            .then(_bindFilterData)
                            .then(() => {
                                cm.updating = false;
                                cm.updatingAvailability = false;
                                cm.searchCompletePercentage = results.SearchCompletePercentage;
                            });
                    }

                    const _getMixpanelResultsCompletePayload = (searchId, results) => ({
                        SearchId: searchId,
                        Count: _.get(results, 'Aggregates.HotelCount', 0),
                        LowestPricedHotel: _.get(results, 'Aggregates.LowestPricedHotel', 0),
                    });

                    function _getPolledSearchResults(searchId) {
                        hotelSearch.getSearchResults(searchId, $routeParams.tripId).then(results => {
                            if (results.SearchCompletePercentage === 100) {
                                let mixpanelData = _.assign(_getMixpanelResultsCompletePayload(searchId, results), {
                                    ProgressiveLoading: true,
                                    FirstLoad: false
                                });
                                analytics.track('mixpanel', 'HotelListingComplete', mixpanelData);
                                cancelInterval();
                            }

                            return results;
                        }, function() {
                            $location.path('hotels');
                        }).then(_postProcessResults);
                    }
                    if ($location.search().disablePaging !== '1') {
                        $location.replace();
                        $location.search('disablePaging', null);
                        cm.req.Paging.Size = 8;
                    }

                    function _setSearchResultsPolling(searchId) {
                        cm.pollingInterval = $interval(() => {
                            _getPolledSearchResults(searchId);
                        }, 1000);
                    }

                    cm.selectHotel = selectHotel;
                    cm.getHotelUrl = getHotelUrl;
                    cm.isKidsFree = trip.IsKidsFree &&
                        (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);
                    cm.isHolidayType = TripType === tripService.tripTypes.Holiday;

                    cm.showChangeToFlight = () => !cm.packagePrice && cm.isHolidayType && cm.isFlexibleTripType && TRPCONFIG.Domain.HotelsOnFlightsEnabled;

                    cm.changeToFlightWorkflow = ev => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        trackChangeToFlightClick(trip);
                        basketService.changeToFlightWorkflow($routeParams.tripId);
                    };

                    cm.bookButton = function() {
                        return resourceService.get('SELECTHOTELTEXT');
                    };

                    if (trip == null) {
                        loggingService.logError(`HotelSearch: tripId:${$routeParams.tripId} returned a null trip`);
                        _unblock();
                        locationService.home();
                        return;
                    }

                    if (trip.HotelsRequest == null) {
                        loggingService.logError(`HotelSearch: tripId:${$routeParams.tripId} returned a trip with a null HotelsRequest: ${JSON.stringify(trip)}`);
                        _unblock();
                        locationService.home();
                        return;
                    }

                    if (TRPCONFIG.Domain.ImmediateSearch) {
                        cm.updatingAvailability = true;
                        hotelSearch.getStaticSearchResults()
                            .then(res => cm.updatingAvailability && _setResults(res));
                    }

                    basketService.getFlight(BasketId).then(flight => {
                        if (EnableForceLoading) {
                            _block();
                        }
                        if (flight) {
                            cm.flight = flight;
                            cm.isPartialCabinClass = isPartialCabinClass(flight.Details.Itinerary.Legs);
                            if (TRPCONFIG.Domain.EnableFlightDetailsWithBrandedFare) {
                                let selectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight') || '{}');
                                if (selectedFlight && selectedFlight.Legs.length) {
                                    selectedFlight.Legs = flight.Details.Itinerary.Legs;
                                    sessionStorage.setItem('storeSelectedFlight', JSON.stringify(selectedFlight));
                                }
                            }
                            sessionStorage.setItem('DefaultFlight', JSON.stringify(flight));
                            sessionStorage.setItem('FlightDetailsId', flight.Details.DetailsId);
                            flightSearch.getDestinationAirports(flight.Details.Itinerary.Legs[0].ArrivalAirport.Code);
                            //if the page has been refreshed we need to reapply the airport code filter if there is a selected flight.
                            if (TRPCONFIG.Domain.AutoFilterByAirport) {
                                hotelSearch.setAirportCodeFilter(flight.Details.Itinerary.Legs[0].ArrivalAirport.Code);
                            }
                            _flightCosts(BasketId)();
                        }
                        if (cm.packagePrice && TRPCONFIG.Domain.MarhabaEnabled) {
                            basketStore.marhabaCost(BasketId).then(c => cm.marhabaCost = c);
                        } else {
                            cm.marhabaCost = 0;
                        }

                        //getFlight will wait if we are in the middle of adding a new flight. That action *may* cause a new
                        //hotel search to be triggered which will results in a new search Id in the trip.
                        //Therefore before we have to get the searchId from the trip again at this point to be sure
                        //we are getting the right value.
                        let searchId;
                        if (EnableForceLoading) {
                            _block();
                        }
                        tripService.getTrip($routeParams.tripId)
                            .then(trip => trip.HotelsRequest.AvailabilitySearchId)
                            .then(s => searchId = s)
                            .then(() => hotelSearch.updateFilterFromFid())
                            .then(() => hotelSearch.getSearchResults(searchId, $routeParams.tripId))
                            .then(results => {
                                let defaultFlight = JSON.parse(sessionStorage.getItem('DefaultFlight'));
                                if (defaultFlight && defaultFlight.Details) {
                                    defaultFlight.Details.Itinerary.FlightId = trip.FlightsRequest && trip.FlightsRequest.SelectedFlight ?
                                    trip.FlightsRequest.SelectedFlight.FlightId : null;
                                    sessionStorage.setItem('DefaultFlight', JSON.stringify(defaultFlight));
                                }
                                if (abTest.progressiveHotelSearchEnabled()
                                    && !!results.SearchCompletePercentage
                                    && results.SearchCompletePercentage < 100) {
                                    _setSearchResultsPolling(searchId);
                                } else {
                                    let mixpanelData = _.assign(_getMixpanelResultsCompletePayload(searchId, results), {
                                        ProgressiveLoading: abTest.progressiveHotelSearchEnabled(),
                                        FirstLoad: true
                                    });
                                    analytics.track('mixpanel', 'HotelListingComplete', mixpanelData);
                                }
                                return results;
                            }, function() {
                                $location.path('hotels');
                            })
                            .then(_postProcessResults);
                    });
                    broker.subscribe('HotelCtrl', 'flightAddedToBasket', _flightCosts(BasketId));
                });
        }

        async function isFlightAvaliable(tripId) {
            if (EnableForceLoading) {
                _block();
            }
            $scope.isFlightLoadingFinished = false;
            if (tripId !== null && tripId !== undefined) {
                const flightRequest = await tripService.getTrip(tripId)
                    .then(trip => {
                        if (trip && trip.FlightsRequest && trip.FlightsRequest.Cabin) {
                        const cabinTypes = { 1: 'ECONOMYCLASS', 2: 'PREMIUMECONOMYCLASS', 8: 'BUSINESSCLASS', 4: 'FIRSTCLASS' };
                        cm.requestedCabinClass = resourceService.get(cabinTypes[trip.FlightsRequest.Cabin]);
                        cm.isUpgradedCabinClass = cm.flight && cm.flight.Details && cm.flight.Details.Itinerary && cm.flight.Details.Itinerary.Legs ?
                        isUpgradedCabinClass(cm.flight.Details.Itinerary.Legs, trip.FlightsRequest.Cabin) : false;
                        }
                        return trip.FlightsRequest;
                    });

                if (flightRequest === null || flightRequest.SelectedFlight === null) {
                    $scope.isFlightLoadingFinished = false;
                    if (EnableForceLoading) {
                        _unblock();
                    }
                    return false;
                }
                $scope.isFlightLoadingFinished = true;
                if (EnableForceLoading) {
                    _unblock();
                }
                return true;
            }
        }

        function hotelsAndTotalsAreZero(hotels, total) {
            return hotels.length === 0 && total === 0;
        }

        function passengerCountOverMax(nonInfants, maxPassengers) {
            return nonInfants > maxPassengers;
        }

        //if we are in a trip and we searched for a specific hotel and we have not already been directed to that hotel
        //then route us automatically through to the hotel page
        function redirectToHotel(data) {
            if ($routeParams.tripId == null) {
                return $q.when(false);
            }
            return tripService.getTrip($routeParams.tripId).then(function(trip) {
                const { BasketId } = trip;

                if (trip.HotelsRequest && trip.HotelsRequest.DirectToHotel && trip.TripType !== tripService.tripTypes.MultiDestHoliday) {
                    return hotelSearch.getDestinationEstabId().then(estabId => {
                        if (estabId > 0 && data.Hotels.length > 0 && parseInt(estabId) === data.Hotels[0].Id) {
                            const boostReason = _.get(data.Hotels, '[0].BoostReason');
                            hotelService.trackHotelClick(estabId, 0, boostReason);
                            basketService.selectHotel($routeParams.tripId, data.Hotels[0], BasketId, null, true);
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
        }

        function _processHotels(hotels, filteredBoardTypes) {
            getFlightMilesEachPassenger();
            setSession(hotels);
            function processHotels(hotel, index) {
                setLowestBoardTypePerHotel(hotel, index);
                setPropertyTypeFrom(hotel, index);
                const preselectedHotelData = sessionStorage.getItem('preselectedHotelData');
                preselectedHotelData !== null ? hotel.inBasket = JSON.parse(preselectedHotelData).d.Itinerary.EstabId === hotel.Id : hotel.inBasket = false;

                // Hide lightbox pin when there are no valid coordinates
                hotel.showLightboxPin = hotel.Latitude && hotel.Longitude;
                hotel.isFamilyFriendly = _.includes(hotel.EstabGroupIds, TRPCONFIG.Domain.FamilyFriendlyEstabGroup);
                hotel.callToBookWithHidePrice = hotel.CallToBookBehaviour === 2;
                hotel.mandatoryExtras = hotelSearch.getMandatoryExtra(hotel);
                hotel.reviewIcon = getReviewIcon(hotel.CustomerRating);
                hotel.HolidayDeposit = hotel.HolidayDeposit;
            }

            function getReviewIcon(customerRating) {
                const reviewMaxAmount = 10;
                const faceClasses = [
                    'icon-face-angry',
                    'icon-face-sad',
                    'icon-face-indifferent',
                    'icon-face-happy',
                    'icon-face-ecstatic'
                ];
                const faceStepSize = reviewMaxAmount / faceClasses.length;
                return faceClasses.reduce((acc, current, i) => (customerRating > (i * faceStepSize)) && (customerRating <= ((i + 1) * faceStepSize)) ? current : acc);
            }

            function setLowestBoardTypePerHotel(hotel) {
                function _translateLowestBoardName(index) {
                    const boardsTranslation = resourceService.get(boards);
                    return boardsTranslation[index];
                }

                function processPrices(hotel) {
                    const cheapestBoardTypes = [];

                    if (hotel.RequestedRooms) {
                        hotel.RequestedRooms.forEach(room => {
                            if (filteredBoardTypes != null && filteredBoardTypes.length !== 0) {
                                room.BoardTypeMinPrices = room.BoardTypeMinPrices
                                    .filter(board =>
                                        filteredBoardTypes.some(filtered =>
                                            board.BoardType === parseFloat(filtered)
                                        )
                                    );
                            }
                            const resolution = _.minBy(room.BoardTypeMinPrices, 'MinCost');

                            if (resolution && !_.includes(cheapestBoardTypes, resolution.BoardType)) {
                                cheapestBoardTypes.push(resolution.BoardType);
                            }
                        });
                    }

                    if (cheapestBoardTypes.length === 1 && !cm.isMultiDestHoliday) {
                        hotel.lowestPriceBoardType = _translateLowestBoardName(cheapestBoardTypes[0]);
                    }
                }

                processPrices(hotel);
            }

            function setPropertyTypeFrom(hotel, index) {
                hotels[index].propertyTypeFrom = resourceService.get(
                    getPropertyTypeFromResKey(
                        hotel.AcomTypeId,
                        hotel.IsVilla
                    )
                );
            }

            hotels.forEach(processHotels);

            return hotels;
        }

        function setSitemapLink(hotels) {
            if (hotels[0].Location !== undefined) {
                currentDestination.getCurrentDestination()
                    .then(dest => {
                        let splitedPath = dest.PagePath.split('/');
                        let orderTarget = pageStrand.toRoute(dest.PageStrand);
                        let opositeStr = `${orderTarget}-in-`;
                        let urlItem = splitedPath[splitedPath.length - 1].replace(opositeStr, '');
                        let matchStrand = TRPCONFIG.Domain.EnableSitemapLinkByPageStrand && TRPCONFIG.Domain.EnableSitemapLinkByPageStrand
                            .some(strand => parseInt(strand) === parseInt(dest.PageStrand));

                        const shouldDisplay = hotelService.getPaginationMode(dest.CountryOwnId)
                            && hotels.length >= 12
                            && matchStrand;

                        const URL = `sitemap/${splitedPath[1]}/${urlItem}`;

                        $scope.sitemapLink = {
                            url: URL,
                            name: dest.ShortTitle,
                            display: shouldDisplay
                        };
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }

        function setPriceDigits(cName, value) {

            let el = document.querySelector(`.${cName}`);
            let num = 0;
            let dec = $locale.NUMBER_FORMATS.GROUP_SEP;

            el.addEventListener('focus', function() {
                this.classList.add('focused');
            });
            el.addEventListener('blur', function() {
                this.classList.remove('focused');
            });
            if (value && value.toString()) {
                num = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, dec);
            }

            return num;
        }

        function _setResults(data) {
            if (data == null) { return $q.when(); }

            const isAutoSearch = $location.search().autoSearch !== '1';
            setSession(data.Hotels);
            return redirectToHotel(data).then(function(redirected) {
                if (!redirected) {
                    hotelSearch.getSortCriterionDescription().then(name => cm.sortedBy = name);
                    cm.hotels = _processHotels(data.Hotels);
                    $scope.$watchCollection('cm.filter.BoardTypes', function(e) {
                        cm.hotels = _processHotels(data.Hotels, e);
                    });
                    cm.total = data.Aggregates.HotelCount;
                    cm.filteredTotal = data.Aggregates.FilteredHotelCount;
                    cm.agg = hotelsFilter.enhanceAggregates(data.Aggregates);
                    cm.enableFacilityFilter = !$.isEmptyObject(cm.agg.HotelsByFacility);

                    cm.enableChildDestinationFilter =
                        !$.isEmptyObject(cm.agg.HotelsByChildDestination) &&
                        !cm.isMultiDestHoliday;
                    cm.enableMultiDestHolidayFilter = cm.isMultiDestHoliday;
                    cm.busy = false;
                    tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(ds => {
                        cm.durationSummary = ds;
                        cm.searchSummary = ds ? `${ds}, ${hotelSearch.getOccupancySummary()}` : '';
                    });

                    hotelSearch.getDestinationTitle().then(title => cm.pageTitle = cm.destinationTitle = title);
                    if (!cm.isMultiDestHoliday) {
                        hotelSearch.getDestinationEstabId().then(destinationEstabId => cm.destinationEstabId = destinationEstabId);
                    }
                    if ($routeParams.tripId) {
                        tripService.getHotelsRequestNumberOfNights($routeParams.tripId)
                            .then(numNights => cm.numNights = numNights);
                    }
                    currentDestination.getCurrentDestination().then(dest => {
                        cm.destination = dest;
                        cm.isTransferMandatory = (dest && dest.DestinationAirports && dest.DestinationAirports.split(',') || [])
                            .includes(...TRPCONFIG.Domain2.IsTransferMandatorySearchDestination);
                    });
                    cm.nonInfants = cm.isKidsFree
                        ? occupancyService.getOnlyPayingIndividuals()
                        : occupancyService.getNumberOfNonInfantPassengers();
                    if (cm.total === 0) {
                        cm.showSearchUnit = true;       //if no results open the search unit
                    }

                    cm.isFlightAvaliable = isFlightAvaliable($routeParams.tripId);
                    cm.hotelsAndTotalsAreZero = hotelsAndTotalsAreZero(cm.hotels, cm.total);
                    cm.passengerCountOverMax = passengerCountOverMax(cm.nonInfants, cm.maxPassengers);

                    tripService.getCurrency($routeParams.tripId).then(cur => cm.currency = cur);
                    broker.publish('hotelListUpdated', data);
                    basketService.getHolidaySearchProgress().then(() => {
                        if (isAutoSearch && !EnableForceLoading) {
                            _unblock();
                        }
                    });

                    hotelSearch.pageIndex()
                        .then(pi => {
                            cm.pageNumber = pi + 1;
                            cm.paging = pagingService.data(cm.pageNumber, hotelSearch.pageSize(), cm.filteredTotal);
                        });
                }
                if (data.Hotels.length > 0) {
                    setSitemapLink(data.Hotels);
                }
                cm.updating = false;

                return redirected;
            });
        }

        function setSession(data) {
            let hotelsSRPData = [];
            data.forEach(h => {
                const roomData = h.RequestedRooms && h.RequestedRooms.length > 0 &&
                    h.RequestedRooms[0].Availability && h.RequestedRooms[0].Availability.length > 0 &&
                    h.RequestedRooms[0].Availability[0].BoardOptions && h.RequestedRooms[0].Availability[0].BoardOptions.length > 0 ?
                    h.RequestedRooms[0].Availability[0].BoardOptions[0] : null;
                let hData = {
                    Id: h.Id,
                    Title: h.Title,
                    AcomType: h.AcomType,
                    Address: h.Address,
                    Country: h.Country,
                    HolidayDeposit: h.HolidayDeposit ? h.HolidayDeposit : null,
                    Location: h.Location,
                    MinCost: h.MinCost,
                    MinHolidayPrice: h.MinHolidayPrice,
                    CityTax: roomData ? roomData.CityTax : 0,
                    IsCityTaxIncludedInPrice: h.IsCityTaxIncludedInPrice || false,
                    Province: h.Province
                };
                hotelsSRPData.push(hData);
            });
            sessionStorage.removeItem('hotelData');
            sessionStorage.removeItem('baseCost');
            sessionStorage.removeItem('SkywardsMiles');
            TRPCONFIG.Domain.SkywardsInfo = null;
            TRPCONFIG.Domain.FlightMiles = null;
            sessionStorage.setItem('hotelSearchResults', JSON.stringify(hotelsSRPData));
        }

        function _modifyResults(data) {
            _setResults(data)
                .then(function(redirected) {
                    if (!redirected) {
                        _bindFilterData();
                        // only force to list tab when it was invoked from sort or filter actions
                        if (_(['filter', 'sort']).includes(data.searchTriggeredBy)) {
                            cm.listTab();
                        }
                    }
                    if (cm.showSlideFilter === true) {
                        scrollTo(0, 0);
                    }
                })
                .finally(function() {
                    cm.updating = false;
                    analytics.endTimer(timerKey);
                });
        }

        function codeIsInGroup(group) {
            return function(code) {
                return cm.agg.HotelsByFacility[group][code] != null;
            };
        }

        function cancelInterval() {
            $interval.cancel(cm.pollingInterval);
            cm.pollingInterval = null;
        }

        function _bindFilterData() {
            cm.filter = hotelSearch.getFilter();
            setFilterHolidayPriceRange();
            cm.nameFilterSet = hotelSearch.filterSet('HotelName');
            cm.starFilterSet = hotelSearch.filterSet('Stars');
            cm.propertyTypeFilterSet = hotelSearch.filterSet('PropertyTypes');
            cm.boardTypeFilterSet = hotelSearch.filterSet('BoardTypes');
            cm.facilityFilterSet = hotelSearch.filterSet('FacilityCodes');
            cm.childDestinationFilterSet = hotelSearch.filterSet('ChildDestinations');
            if (cm.agg != null) {
                for (const group in cm.agg.HotelsByFacility) {
                    cm[`${group}FacilityFilterSet`] = arrayUtil.any(cm.filter.FacilityCodes, codeIsInGroup(group));
                }
                cm.seasonalDealFilter = TRPCONFIG.Domain.ActiveSeasonalDeals && TRPCONFIG.Domain.ActiveSeasonalDeals.find(deal => _.has(cm.agg, deal.ApiAggregateName));
            }
            cm.minHolidayPriceFilterSet = hotelSearch.rangeFilterSet('HolidayPriceRange', 'Min');
            cm.maxHolidayPriceFilterSet = hotelSearch.rangeFilterSet('HolidayPriceRange', 'Max');
            cm.ratingFilterSet = hotelSearch.rangeFilterSet('RatingRange', 'Min');
            cm.groupFilterSet = hotelSearch.bitFilterSet('FilterByEstabGroup');
            cm.showEstabGroupFilter = hotelSearch.estabGroupFilterAvailable();
            if (TRPCONFIG.Domain.PriceBucketFilterEnabled) {
                cm.anyFilter = cm.propertyTypeFilterSet || cm.nameFilterSet || cm.starFilterSet || cm.boardTypeFilterSet || cm.ratingFilterSet || cm.groupFilterSet || cm.facilityFilterSet || cm.childDestinationFilterSet;
            } else {
                cm.anyFilter = cm.propertyTypeFilterSet || cm.nameFilterSet || cm.starFilterSet || cm.boardTypeFilterSet || cm.minPriceFilterSet || cm.maxPriceFilterSet || cm.ratingFilterSet || cm.groupFilterSet || cm.facilityFilterSet || cm.childDestinationFilterSet || cm.minHolidayPriceFilterSet || cm.maxHolidayPriceFilterSet;
            }
        }

        function setFilterHolidayPriceRange() {
            if (cm.filter.HolidayPriceRange && cm.filter.HolidayPriceRange.Min && cm.filter.HolidayPriceRange.Max) {
                cm.filter.HolidayPriceRange.Min = Math.trunc(cm.filter.HolidayPriceRange.Min);
                cm.filter.HolidayPriceRange.Max = Math.trunc(cm.filter.HolidayPriceRange.Max);
            }
        }

        function _block() {
            const isHoliday = $route.current && $route.current.area === 'holidays';
            $scope.$emit('block', {
                title: resourceService.get($routeParams.tripId || $location.search().autoSearch === '1' ? 'SEARCHINGHOTELS' : 'LOADINGHOTELS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: isHoliday ? 'holidays-hotelSearchCtrl-isHolidayTrue' : 'hotels-hotelSearchCtrl-isHolidayFalse'
            });
        }

        function _unblock() {
            broker.publish('unblock');
            $scope.$emit('unblock');
        }

        function tabClass(tab) {
            return tab === cm.tab ? 'active' : '';
        }

        function setTab(tab) {
            if (cm.tab !== tab) {
                cm.tab = tab;
            }
        }

        function listTab() {
            cm.setTab('list');
        }

        function filterTab() {
            if (cm.hotels.length > 0 || cm.anyFilter) {
                _bindFilterData();
                cm.setTab('filter');
            }
        }

        function sortTab() {
            if (cm.hotels.length > 0 || cm.anyFilter) {
                cm.setTab('sort');
            }
        }

        function infoTab() {
            cm.tab = 'info';
        }

        function applyFilters() {
            hotelSearch.filter();
        }

        function applySort() {
            hotelSearch.sort(cm.req.SortCriterion);
        }

        function page(num, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            cm.updating = true;
            hotelSearch.page(num - 1).then(_setResults);
        }

        function resetFilters() {
            hotelSearch.resetFilters();
        }

        function removeFilter(filterName) {
            hotelSearch.removeFilter(filterName);
        }

        function removeArrayFilter(filterName, item) {
            hotelSearch.removeArrayFilter(filterName, item);
        }

        function resetRangeFilter(filterName, range) {
            hotelSearch.resetRangeFilter(filterName, range);
        }

        function resetArrayFilter(filterName) {
            hotelSearch.resetArrayFilter(filterName);
        }

        function resetBitFilter(filterName) {
            hotelSearch.resetBitFilter(filterName);
        }

        function showSpinner(hotel) {
            return selectedHotel === hotel;
        }

        function startAgain() {
            basketService.restartCurrentWorkflow($routeParams.tripId);
        }

        function requestedHotelNotAvailable(i, hotel) {
            let isNotAvailable = !cm.anyFilter &&
                i === 0 &&
                _.get(cm, 'paging.page') === 1 &&
                cm.destinationEstabId !== 0 &&
                !cm.updating &&
                hotel.Id !== parseInt(cm.destinationEstabId);
            if (isNotAvailable) {
                analytics.trackRequestedHotelNotAvailable(cm.destinationEstabId);
            }
            return isNotAvailable;
        }

        // Desktop
        function toggleMap() {
            cm.showMap = !cm.showMap;
        }

        function popupMap(hotel) {
            cm.showPopupMap = !cm.showPopupMap;
            cm.activeHotel = hotel;
        }

        function _getReviews(hotel, page) {
            cm.loadingReviews = true;
            if (page === 1) {
                cm.loadingFirstReviews = true;
            }
            return reviewService.getReviews(hotel, page - 1).then(function(result) {
                cm.reviews = result.reviews;
                cm.loadingReviews = false;
                cm.loadingFirstReviews = false;
                cm.reviewPaging = pagingService.data(page, 10, hotel.CustomerRatingCount);
            });
        }

        function showReviews(hotel, ev) {
            ev.preventDefault();
            cm.reviews = [];
            cm.selectedHotel = hotel;
            cm.reviewPaging = pagingService.data(1, 10, hotel.CustomerRatingCount);
            _getReviews(hotel, cm.reviewPaging.page);
            cm.reviewsShowing = true;
            ev.stopPropagation();
        }

        if (TRPCONFIG.Domain.ReviewsEnabled) {
            cm.pageReviews = page => {
                _getReviews(cm.selectedHotel, page);
            };
        }

        function starName(stars) {
            return stars > 0 ? (`${stars} ${resourceService.get('STAR')}`) : resourceService.get('UNRATED');
        }

        function openImageGallery(hotel, e) {
            e.preventDefault();

            const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
            const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;

            cm.hotelImageIndex = 0;
            cm.hotelImages = [];
            for (let i = 0, l = hotel.NumberOfPhotos; i < l; i++) {
                cm.hotelImages.push({
                    src: imageService.getImageUrl(hotel.Id, w, h, i, false)
                });
            }
            cm.showHotelImages = true;
        }

        function openSlideFilter(e) {
            e.preventDefault();
            cm.showSlideFilter = true;
        }

        broker.subscribe('HotelCtrl', 'toggleMap', function() {
            toggleMap();
        });

        broker.subscribe('HotelCtrl', 'showReviews', function(ev) {
            showReviews(ev.data.hotel, ev.data.event);
        });

        function toggleSearchUnit() {
            cm.showSearchUnit = !cm.showSearchUnit;
        }

        function toggleHFJShowSearch() {
            cm.HFJShowSearch = !cm.HFJShowSearch;
            if (cm.HFJShowSearch) {
                hotelSearch.toggleSearch('[ng-show="cm.HFJShowSearch"]');
                let el = document.querySelectorAll('.ekh-search-panel')[0];
                el.classList.remove('panel-hide');
            }
        }

        function closeInvalidHolidayStartDateModal(ev) {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            cm.showInvalidHolidayStartDateModal = false;
        }

        function trackHotelClick(hotel, trip) {
            analytics.trackEvent({ category: 'searches', action: 'hotelPage' });
            preferences.getHotelSortOrder().then(sc => {
                hotelService.trackHotelClick(
                    hotel.Id,
                    hotel.HotelIndex,
                    hotel.BoostReason,
                    sc,
                    _.get(trip, 'HotelsRequest.AvailabilitySearchId')
                );
                let trackingProps = {
                    RepeatHotelClicked: !!_.get(hotel, 'UserClicksRank'),
                    WinnerClicked: _.has(hotel, 'HotelAward'),
                    ListRanking: _.get(hotel, 'HotelIndex') || 0,
                    TopDealClicked: _.get(hotel, 'Recommended'),
                    FamilyFriendlyClicked: _.get(hotel, 'isFamilyFriendly') && !_.get(hotel, 'Recommended'),
                    BlackFridayDeal: !!_.get(hotel, 'BlackFridayDeal') || !!_.get(hotel, 'JanuarySale') || !!_.get(hotel, 'SummerOffer'),
                    PromoDiscount: false
                };
                if (trip) {
                    const { adults, children } = occupancyService.getTotalPeopleCounts(_.get(trip, 'HotelsRequest.Rooms'));
                    angular.extend(trackingProps, {
                        Rooms: _.get(trip, 'HotelsRequest.Rooms.length'),
                        Adults: adults,
                        Children: children
                    });
                    if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                        basketStore.flightCost(trip.BasketId).then(FlightCost => {
                            analytics.track('mixpanel', 'HotelListingSkip', {
                                Id: _.get(hotel, 'Id'),
                                ProvinceId: _.get(hotel, 'ProvinceId'),
                                LocationId: _.get(hotel, 'LocationId'),
                                Adults: adults,
                                Children: children,
                                FlightCost
                            });
                        });
                    }
                }
                if (hotel.SpecialOfferText) {
                    angular.extend(trackingProps, {
                        PromoDiscount: true,
                        PromoCampaign: hotel.SpecialOfferText
                    });
                }
                analytics.track('mixpanel', 'HotelListingClick', trackingProps);
            });
        }

        function trackChangeToFlightClick(trip) {
            if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
                const { BasketId, FlightsRequest, HotelsRequest } = trip;
                basketStore.flightCost(BasketId).then(FlightCost => {
                    const { adults, children } = occupancyService.getTotalPeopleCounts(_.get(HotelsRequest, 'Rooms'));
                    analytics.track('mixpanel', 'HotelListingSkip', {
                        Id: _.get(FlightsRequest, 'Destination.Id'),
                        ProvinceId: _.get(FlightsRequest, 'Destination.ProvinceId'),
                        LocationId: _.get(FlightsRequest, 'Destination.LocationId'),
                        Adults: adults,
                        Children: children,
                        FlightCost
                    });
                });
            }
        }

        cm.trackPriceBucket = function(label) {
            const typeTitles = {
                hotels: 'Hotels',
                flights: 'Flights',
                holidays: 'Holidays',
            };
            let title = cm.showChangeToFlight() ? 'flights' : $route.current.area;
            analytics.track('mixpanel', 'PriceBucketClick', {
                TypeTitle: typeTitles[title] || null,
                Priceband: label.replace(/\D/g, '') || label,
            });
        };

        cm.isLeftSectionRibbon = function(ribbon) {
            const ribbonsIdList = TRPCONFIG.Domain.LeftAllignedRibbonsList;
            let isLeftDirected = ribbonsIdList.includes(ribbon.Id.toString());
            return isLeftDirected;
        };

        function isSeasonalDeals(hotel) {
            return _.some(TRPCONFIG.Domain.ActiveSeasonalDeals, d => hotel.OverlaysNew && d.OverlayId === hotel.OverlaysNew[0].Id);
        }

        $scope.$on('$destroy', function() {
            cancelInterval();
            broker.unsubscribe('HotelCtrl');
        });

        cm.showMore = function() {
            cm.updating = true;
            let hotels = cm.hotels;
            hotelSearch.page(cm.hotelsChunkNumber++)
                .then(data => {
                    data.Hotels = [...hotels, ...data.Hotels];
                    return data;
                }).then(_setResults);
        };

        cm.showFlightDetails = function() {
            const passengers = occupancyService.getTotalPeopleCounts();
            const config = {
                flight: cm.flight.Details.Itinerary,
                passengers,
                customiseMessage: cm.isHotelFirstJourney,
            };
            broker.publish('showModalFlightDetails', config);
        };

        cm.keepHotel = function(hotel, ev) {
            // we can't use history.back() here because hotel can be opened in the new tab and history will be empty
            // or user can click back and after that forward button in the browser
            // and we cant just use $location.path(urlStoreService.getPreviousURL()) because user can click home button after that back button and click keep
            // also we can't use select hotel method because user will be redirected to room selection page
            const previousURL = urlStoreService.getPreviousURL();
            const applicablePathRegEx = '(/|/holidays/|/hotels)(flights|hotels|options|book|([0-9a-fA-F-]+))/[0-9a-fA-F-]+';
            let cameFromWrongPath = urlStoreService.cameFromWrongPath(applicablePathRegEx);

            if (!cameFromWrongPath) {
                const cameFromChooseFlightPage = previousURL.match('(holidays/flights/)[0-9a-fA-F-]+') !== null;
                const cameFromChooseRoomPage = previousURL.match('(holidays/)[0-9a-fA-F-]+(/)[0-9]+') !== null;
                const isHotelSelected = sessionStorage.getItem('preselectedHotelData') !== null;
                const URLHistory = urlStoreService.getURLHistory();
                let postPreviousURL = null;

                if (URLHistory !== null && URLHistory.length >= 3) {
                    postPreviousURL = URLHistory.slice(-3)[0];
                }
                // if you click 'keep hotel' it redirect you back to the flight selection, if you click 'keep flight' it redirect you back to the hotel selection
                // we need this check to avoid the loop between 'keep hotel' and keep 'flight buttons'
                if ((cameFromChooseFlightPage || cameFromChooseRoomPage) && isHotelSelected && postPreviousURL !== null) {
                    // when ab test (hotel first) will be ended, we can remove if-else below and just put $location.path(postPreviousURL);
                    // it looks like useless check, but let's keep it here for now just in case, since local smoke test was successful
                    if (postPreviousURL === '/' || postPreviousURL === '/holidays' || postPreviousURL === '/hotels') {
                        cm.selectHotel(hotel, ev);
                    } else {
                        $location.path(postPreviousURL);
                    }
                } else {
                    $location.path(previousURL);
                }
            } else {
                cm.selectHotel(hotel, ev);
            }
        };

        cm.getFlightInfo = function(flight) {
            if (flight) {
                let legs = flight.Details.Itinerary.Legs;
                let airportCodes = [];
                let journeyType = 'Direct';
                let stopText = 'Stop';

                if (legs.length === 2) {
                    for (let i = 0; i < legs.length; i++) {
                        let segments = legs[i].Segments;
                        let segmentCount = segments.length - 1;

                        if (segments.length > 1) {
                            if (segmentCount > 1) {
                                stopText = 'Stops';
                            }
                            journeyType = `${segmentCount} ${stopText}`;
                        }

                        airportCodes.push(legs[i].DepartureAirport.Code);
                        if (airportCodes.length > 1) {
                            let text = `${airportCodes[0]} - ${airportCodes[1]} (${journeyType})`;
                            return text;
                        }
                    }
                }
            }
        };

        function isPartialCabinClass(legs) {
            if (legs && legs[0].Segments && legs[1].Segments) {
                const cabinClassArr1 = legs[0].Segments.map(x => {
                    return x.Cabin;
                });
                const cabinClassArr2 = legs[1].Segments.map(x => {
                    return x.Cabin;
                });
                const cabinClassArr = cabinClassArr1.concat(cabinClassArr2);
                const allEqual = arr => arr.every(val => val !== undefined && val === arr[0]);
                const result = allEqual(cabinClassArr);
                return !result;
            }
        }

        function isUpgradedCabinClass(legs, requestedCabin) {
            if (legs && legs[0].Segments && legs[1].Segments && requestedCabin) {
                const cabinClassArr1 = legs[0].Segments.map(x => {
                            return x.Cabin;
                    });
                const cabinClassArr2 = legs[1].Segments.map(x => {
                            return x.Cabin;
                    });
                const cabinClassArr = cabinClassArr1.concat(cabinClassArr2);
                return !cabinClassArr.includes(requestedCabin);
            }
        }

        cm.showTermsAndConditionsPopup = function(data) {
            const headerText = resourceService.get('PROMOTIONTERMSANDCONDITIONS');
            return infoPopupService.showPopup({
                popupHeader: headerText,
                popupMessage: data
            });
        };

        cm.findRoomName = function(rooms) {
            if (rooms && rooms[0].BoardTypeMinPrices[0] && rooms[0].BoardTypeMinPrices[0].RoomDescription) {
                return rooms[0].BoardTypeMinPrices[0].RoomDescription;
            }
        };

        cm.facilitiesIcon = function(code) {
            return cm.facilitiesIcons[code];
        };

        cm.promotionColour = function(promos) {
            if (promos) {
                let overlayTypeId = promos.OverlayTypeId;

                if (overlayTypeId === 3) {
                    cm.promoColour = 'blue';
                } else if (overlayTypeId === 13) {
                    cm.promoColour = 'black';
                } else if (overlayTypeId === 14) {
                    cm.promoColour = 'red';
                }

                return cm.promoColour;

            }
        };

        cm.promotions = function(promos) {
            if (promos) {
                let text = promos.Text;
                let textArr = [];

                text = text.replace('||', '');
                if (text.match('|')) {
                    text = text.split('|');
                    for (let i = 0; i < text.length; i++) {
                        textArr.push(text[i]);
                    }
                    text = textArr.join(' ');
                }

                return text;

            }

        };
    }
})();
